import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactSVG } from 'react-svg';
import RangeSlider from 'react-bootstrap-range-slider';

import { editContent } from '../../modules/editor';
import useDebounce from '../../hooks/useDebounce';
import useOnClickOutside from  '../../hooks/useOnClickOutside';

import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import { RootState } from '../../modules';
import { getPathAfterBuild } from '../../util/file';

type Props = {
	target: string;
	currentValue: string;
	name: string;
	imagePath: string;
	imageType: string;
	imageInfo: any;
	maxWidth: number;
};

function InputSlider({ target, currentValue, name, imagePath, imageType, imageInfo, maxWidth }: Props) {

	const initValue = () => {
		if (currentValue === '100%') {
			return currentValue;
		} 
		return imageInfo?.clientWidth;
	}

	const dispatch = useDispatch();
	
	const [open, setOpen] = useState(false);
	const [debounceValue, inputValue, setInputValue] = useDebounce<number>(
		initValue(), 
		50
	);

	const screenMode = useSelector((state: RootState) => state.editor.ui.screenMode);

	useEffect(() => {
		if (imageInfo?.clientWidth !== undefined) {
			setInputValue(imageInfo?.clientWidth);
		}
	}, [imageInfo]);

	const ref = useRef(null);
	useOnClickOutside(ref, ():any => {
		setOpen(false);
  });

	const iconImage = (path) => {
		const context = require.context('../../assets/images/', true);
		return getPathAfterBuild(context, path);
	};
 
	const toggleOpen = () => {
		setOpen(!open);
	}

	const onChangeInput = (value:string) => {	
		if (value === '0') {
			setInputValue(1);
			return;
		}
		setInputValue(Number(value));
	}

	const tooltipLabel = (value:any) => {		
		return `${value}px`;
	}

	useEffect(() => {
		if (debounceValue === 0) {
			return;
		}
		
		if (screenMode === 	'desktop') {
			let value = maxWidth === Number(debounceValue) ? '100%' :  `${debounceValue}px`;
			dispatch(editContent({ target: target, data: value }));
		}

		if (currentValue === '100%' && debounceValue < maxWidth) {
			dispatch(editContent({ target: target.replace('width', 'textAlign'), data: 'center' }));
		}

	}, [debounceValue]);

	return (
		<div className="input-slider">
			<button 
				className={open ? 'btn input-slider-btn active' : 'btn input-slider-btn'}
				onClick={toggleOpen}
			>
				{
					imageType === 'svg' ? (
						<ReactSVG src={iconImage(`./${imagePath}${name}.${imageType}`)} height="16" />
					) : (
						<img src={iconImage(`./${imagePath}${name}.${imageType}`)} height="16" />
					)
				}
			</button>
			{
				open && (
				<div className="input-slider-body" ref={ref}>
					<RangeSlider
						value={inputValue}
						onChange={(e:any) => {onChangeInput(e.target.value)}}
						tooltipLabel={tooltipLabel}
						min={0}
						max={maxWidth}
						step={2}
					/>
				</div>
				)
			}
		</div>
	);
}

InputSlider.defaultProps = {
};

export default InputSlider;